<template>
  <v-main>
    <!-- THIS VIEW IS OPTMIZED FOR IPAD SIZE (MIN 1024px) -->
    <v-container grid-list-md fluid >
      <v-layout row wrap>
        <v-flex xs12 sm5>
          <h4 class="mt-n2 mb-1">{{$t("Classifier")}} - {{clasReg.Registration.ArticleName}} ({{clasReg.Registration.VehicleLicensePlateNo}} - {{clasReg.Registration.ScanXRegNo}})</h4>
          <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
          <v-card class="scrollcard" :height="this.$vuetify.breakpoint.height-115" v-else raised>
            <v-card-text>
              <v-form ref="form" ma-n5>

                  <template v-for="article in form.articles">
                    <v-layout v-if="showArticle(article)" :key="article.id" row wrap class="textsize-svs mb-2">
                        <v-text-field
                        :label="article.text + ' - ' + article.groupNo + '. ' + $t('GroupName' + article.groupNo)"
                        :placeholder="article.text + ' - ' + article.groupNo + '. ' + $t('GroupName' + article.groupNo)"
                        dense
                        outlined
                        hide-details="true"
                        :class="bold(article.value)+' valuefield'"
                        v-model="article.value"
                        @change="recalc"
                        v-on:keypress="isNumber()">
                          <template v-slot:append>
                            <v-btn class="mt-1" rounded x-small @click="article.value = ''; recalc()"><v-icon>clear</v-icon></v-btn>
                          </template>
                        </v-text-field>
                        <label style="min-width: 30px" :class="'mt-2 ml-2 mr-2 ' + bold(article.value)">{{ article.unit }}</label>
                        <v-btn v-if="article.unit === 'Kg'" class="mt-1" small color="info" @click="article.value = form.MissingWeight; recalc()"><v-icon>add</v-icon></v-btn>
                        <v-btn v-else class="mt-1" small><v-icon></v-icon></v-btn>
                    </v-layout>
                  </template>

              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm7>
          <v-card v-if="!loading" raised class="mt-5 grow">
            <v-card-text>
              <v-form ref="form" v-model="valid">
                <v-select outlined :items="sortMethods" hide-details="true" v-model="clasReg.SortMethod" @change="form.sortingChanged = true" :item-text="i => $t(i.text)" :label="$t('Sorting method')"></v-select>
                <h4 class="mt-1 mb-1">{{ $t("Article groups") }}</h4>
                <v-layout row wrap>
                  <v-card card>
                    <v-flex xs12 md12>
                      <v-layout row wrap class="textsize-svs">
                        <v-flex d-flex xs4><v-checkbox :label="'1. ' + $t('GroupName1')" v-model="form.group1" @change="groupChanged" row wrap class="mt-1 mb-n6" style="padding: 0px 0px 0px 14px" :color="'primary'"></v-checkbox></v-flex>
                        <v-flex d-flex xs4><v-checkbox :label="'2. ' + $t('GroupName2')" v-model="form.group2" @change="groupChanged" row wrap class="mt-1 mb-n6" style="padding: 0px 0px 0px 14px" :color="'primary'"></v-checkbox></v-flex>
                        <v-flex d-flex xs4><v-checkbox :label="'3. ' + $t('GroupName3')" v-model="form.group3" @change="groupChanged" row wrap class="mt-1 mb-n6" style="padding: 0px 0px 0px 14px" :color="'primary'"></v-checkbox></v-flex>
                        <v-flex d-flex xs4><v-checkbox :label="'4. ' + $t('GroupName4')" v-model="form.group4" @change="groupChanged" row wrap class="mt-1 mb-n6" style="padding: 0px 0px 0px 14px" :color="'primary'"></v-checkbox></v-flex>
                        <v-flex d-flex xs4><v-checkbox :label="'5. ' + $t('GroupName5')" v-model="form.group5" @change="groupChanged" row wrap class="mt-1 mb-n6" style="padding: 0px 0px 0px 14px" :color="'primary'"></v-checkbox></v-flex>
                        <v-flex d-flex xs4><v-checkbox :label="'6. ' + $t('GroupName6')" v-model="form.group6" @change="groupChanged" row wrap class="mt-1 mb-n6" style="padding: 0px 0px 0px 14px" :color="'primary'"></v-checkbox></v-flex>
                        <v-flex d-flex xs4><v-checkbox :label="'7. ' + $t('GroupName7')" v-model="form.group7" @change="groupChanged" row wrap class="mt-1 mb-n6" style="padding: 0px 0px 0px 14px" :color="'primary'"></v-checkbox></v-flex>
                        <v-flex d-flex xs4><v-checkbox :label="'8. ' + $t('GroupName8')" v-model="form.group8" @change="groupChanged" row wrap class="mt-1 mb-n6" style="padding: 0px 0px 0px 14px" :color="'primary'"></v-checkbox></v-flex>
                        <v-flex d-flex xs4><v-checkbox :label="'9. ' + $t('GroupName9')" v-model="form.group9" @change="groupChanged" row wrap class="mt-1 mb-n6" style="padding: 0px 0px 0px 14px" :color="'primary'"></v-checkbox></v-flex>
                        <v-flex d-flex xs4><v-checkbox :label="'10. ' + $t('GroupName10')" v-model="form.group10" @change="groupChanged" row wrap class="mt-1 mb-n6" style="padding: 0px 0px 0px 14px" :color="'primary'"></v-checkbox></v-flex>
                        <v-flex d-flex xs4><v-checkbox :label="'11. ' + $t('GroupName11')" v-model="form.group11" @change="groupChanged" row wrap class="mt-1 mb-n6" style="padding: 0px 0px 0px 14px" :color="'primary'"></v-checkbox></v-flex>
                      </v-layout>
                    </v-flex>
                  </v-card>
                </v-layout>
                <h4 class="mt-1 mb-1">{{ $t("Quantities") }}</h4>
                <v-layout row wrap>
                  <v-card card class="mt-0 mb-3 grow">
                    <v-flex xs12 md12>
                      <v-layout row wrap class="textsize-svs" style="padding: 4px 4px 10px 14px">
                        <v-flex d-flex xs6 class="mt-1 mb-n2">{{$t("Weight")}}:</v-flex>
                        <v-layout><v-spacer></v-spacer><v-flex d-flex xs6 class="mt-1 mb-n2 mr-3">{{Math.abs(clasReg.Registration.WeightNet)}} kg</v-flex></v-layout>
                        <v-flex d-flex xs6 class="mt-1 mb-n2">{{$t("Gross")}}:</v-flex>
                        <v-layout><v-spacer></v-spacer><v-flex d-flex xs6 class="mt-1 mb-n2 mr-3">{{form.GrossWeight}} kg</v-flex></v-layout>
                        <v-flex d-flex xs6 class="font-weight-bold mt-1 mb-n2">{{$t("Missing sorting")}}:</v-flex>
                        <v-layout><v-spacer></v-spacer><v-flex d-flex xs6 class="mt-1 mb-n2 mr-3" :style="form.MissingWeight ? 'background:#2196F3;color:white' : 'background:#439946;color:white'">{{form.MissingWeight}} kg</v-flex></v-layout>
                        <v-flex d-flex xs6 class="mt-1 mb-n2">{{$t("Deduction")}}:</v-flex>
                        <v-layout><v-spacer></v-spacer><v-flex d-flex xs6 class="mt-1 mb-n2 mr-3">{{form.DeductionWeight}} kg</v-flex></v-layout>
                        <v-flex d-flex xs6 class="font-weight-bold mt-1 mb-n2">{{$t("Net")}}:</v-flex>
                        <v-layout><v-spacer></v-spacer><v-flex d-flex xs6 class="font-weight-bold mt-1 mb-n2 mr-3">{{form.NetWeight}} kg</v-flex></v-layout>
                      </v-layout>
                  </v-flex>
                  </v-card>
                </v-layout>
                <v-layout row wrap>
                  <v-card card class="mt-0 mb-3 grow">
                    <v-flex>
                      <v-layout row wrap class="textsize-svs" style="padding: 4px 4px 10px 14px">
                        <v-flex d-flex class="mt-3 mb-n2">{{$t("Minutes")}}:</v-flex>
                        <v-flex d-flex class="mt-3 mb-n2">{{clasReg.MinutesUsed + ' min'}}</v-flex>
                        <v-flex d-flex class="mt-1 mb-n2"><v-btn :loading="starting" class="icon" @click="start" :color="starting ? 'success' : ''">{{$t('Start')}}</v-btn></v-flex>
                        <v-flex d-flex class="mt-1 mb-n2"><v-btn @click="pause" :color="starting ? 'primary' : ''">{{$t('Pause')}}</v-btn></v-flex>
                      </v-layout>
                  </v-flex>
                  </v-card>
                </v-layout>

                <v-select :items="form.remainingArticles" hide-details="true" v-model="clasReg.RemainingArticleNo" :item-text="i => i.no" :label="$t('Rest Article for remaining amount')" @change="form.remainingArticleChanged = true"></v-select>
                <v-text-field v-if="!isHide('Comment') && isRequired('Comment')" :readonly="isReadonly('Comment')" v-model="clasReg.Registration.Comment1" @change="form.commentChanged = true" :label="$t('Comment')" :maxlength="100"></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions class="mt-n6">
              <v-btn v-if="this.$route.params.showAcceptBtn" :loading="saving" @click="approve" color="info">{{$t('Accept')}} {{buttonAppend}}</v-btn>
              <v-spacer></v-spacer>
              <v-btn :loading="saving" min-width="97px" :disabled="!valid" @click="saveAndLeave" color="success">{{ct.SaveBtnText}} {{buttonAppend}}</v-btn>
              <v-btn color="primary" @click="saveClassifierRegistrationCancel(); preventLeave = false; $router.go(-1)">{{$t("Cancel")}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>

        <!-- CONFIRM MISSING WEIGHT NOT 0 -->
        <v-dialog
          v-model="confirmMissingWeightDialog" max-width="400">
          <v-card>
            <v-card-title class="headline">{{$t("Missing sorting")}} {{form.MissingWeight}} kg</v-card-title>
            <!--template v-if="!showRecalc(clasReg)">
              <v-card-text>{{$t("FixSortingWeightDescription")}}</v-card-text>
            </template>
            <template v-else-->
            <template>
              <v-card-text>{{$t("MissingWeightDescription")}}</v-card-text>
              <v-card-text class="font-weight-bold">{{$t("MissingWeightRecalculation")}}</v-card-text>
            </template>
            <v-card-actions>
              <v-spacer></v-spacer>
              <!--template v-if="!showRecalc(clasReg)">
                <v-btn color="success" @click="confirmMissingWeightDialog = false">{{$t("Ok")}}</v-btn>
              </template>
              <template v-else-->
              <template>
                <v-btn color="success" @click="confirmMissingWeightDialog = false; form.approvedReg = clasReg; saveAndLeave()">{{$t("Yes")}}</v-btn>
                <v-btn color="primary" @click="confirmMissingWeightDialog = false">{{$t("No")}}</v-btn>
              </template>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import { app } from '@/main'
import * as Classifier from '@/modules/classifier/classifier'
import ct from '@/core/mixins/common-translations'
import rules from '@/core/mixins/common-rules'
import preventLeave from '@/core/mixins/preventLeave'
import * as DateUtil from '@/core/date'

export default {
  mixins: [ct, rules, preventLeave],
  data: () => ({
    loading: true,
    saving: false,
    valid: true,
    redirectTo: 'classifier-registrations',
    starting: false,
    startTimer: null,
    sortMethods: null, // loads via parameters
    groupedArticles: null, // loads via parameters
    opendGroup: [false, false, false, false, false, false, false, false, false, false, false, false],
    form: {
      articles: [], // loads/converts from clasReg.Articles
      sortingChanged: null,
      group1: null,
      group2: null,
      group3: null,
      group4: null,
      group5: null,
      group6: null,
      group7: null,
      group8: null,
      group9: null,
      group10: null,
      group11: null,
      minChanged: null,
      commentChanged: null,
      GrossWeight: 0,
      MissingWeight: 0,
      DeductionWeight: 0,
      NetWeight: 0,
      approvedReg: null,
      remainingArticles: [],
      remainingArticleChanged: null
    },
    clasReg: {
      Id: '00000000-0000-0000-0000-000000000000',
      Registration: {
        ArticleName: '',
        VehicleLicensePlateNo: '',
        WeightNet: 0
      }
    },
    confirmMissingWeightDialog: false,
    savedText: 'Saved',
    approvedText: 'Approved'
  }),
  computed: {
  },
  methods: {
    showRecalc () {
      // Only show Recalc message when WeightNet = 0
      return this.clasReg.Registration.WeightNet === 0
    },
    start () {
      this.starting = true
      this.form.minChanged = true
      // Update MinutesUsed (in memory) on a timer - every 60 seconds.
      // But F5 Refresh will reset MinutesUsed (Enhance: Could be saved temp in cookie on id key - if customer pays)
      this.startTimer = setInterval(async () => { this.clasReg.MinutesUsed += 1 }, 60 * 1000)
    },
    pause () {
      this.starting = false
      // Pause timer
      if (this.startTimer) clearInterval(this.startTimer)
    },
    recalc () {
      // Recalculate memory amounts (GrossWeight, MissingWeight, DeductionWeight & NetWeight)
      this.form.GrossWeight = 0
      this.form.DeductionWeight = 0
      this.form.articles.forEach(item => {
        if (item.unit === 'Kg' && item.groupNo !== '10') this.form.GrossWeight += Math.abs((item.value !== '' ? item.value : 0))
        if (item.unit === 'Kg' && item.groupNo === '10') this.form.DeductionWeight += Math.abs((item.value !== '' ? item.value : 0))
      })
      this.form.NetWeight = Math.abs(this.form.GrossWeight) - Math.abs(this.form.DeductionWeight)
      this.form.MissingWeight = Math.abs(this.clasReg.Registration.WeightNet) - Math.abs(this.form.GrossWeight + this.form.DeductionWeight)
      // Possible articles for remaining amount
      this.getRemainingArticles()
    },
    getRemainingArticles () {
      // Find currentOpenedArticles (XNET-7046: Exclude Group 10 - Deduction aticles in RemainingArticles list for "Rest Article for remaining amount")
      const currentOpenedArticles = this.groupedArticles.filter(a =>
        a.groupNo === (this.form.group1 ? '1' : '') || a.groupNo === (this.form.group2 ? '2' : '') || a.groupNo === (this.form.group3 ? '3' : '') || a.groupNo === (this.form.group4 ? '4' : '') ||
        a.groupNo === (this.form.group5 ? '5' : '') || a.groupNo === (this.form.group6 ? '6' : '') || a.groupNo === (this.form.group7 ? '7' : '') || a.groupNo === (this.form.group8 ? '8' : '') ||
        a.groupNo === (this.form.group9 ? '9' : '') || a.groupNo === (this.form.group11 ? '11' : '')).map(item => {
        return {
          id: item.obj.Id,
          value: '',
          no: item.no,
          name: item.name,
          text: item.text,
          unit: item.unit,
          groupNo: item.groupNo
        }
      })

      // Add selected remain article
      if (this.clasReg.RemainingArticleNo) {
        const remain = this.groupedArticles.filter(a => a.no === this.clasReg.RemainingArticleNo).map(item => {
          return {
            id: item.obj.Id,
            value: '',
            no: item.no,
            name: item.name,
            text: item.text,
            unit: item.unit,
            groupNo: item.groupNo
          }
        })
        if (remain[0]) { currentOpenedArticles.unshift(remain[0]) } // add selected
      }

      // Possible articles for remaining amount with kg and not already with filled value
      this.form.remainingArticles = currentOpenedArticles.filter(a => a.unit === 'Kg').map(item => {
        return {
          no: item.no + ' - ' + item.name,
          value: item.no
        }
      })

      // Do not use as remaining article if already in use (have value)
      const activeArticles = this.form.articles.filter(a => a.unit === 'Kg' && !a.value).map(item => {
        return {
          no: item.no + ' - ' + item.name,
          value: item.no
        }
      })
      this.form.remainingArticles = this.form.remainingArticles.filter(r => activeArticles.some(a => a.no === r.no))

      this.form.remainingArticles.unshift({ no: '(' + this.$t('None') + ')', value: '' }) // Always add empty article
      if (this.form.articles.some(a => a.value && a.no === this.clasReg.RemainingArticleNo)) {
        this.clasReg.RemainingArticleNo = ''
        this.$root.$message.showError(this.$t('Rest Article for remaining amount') + ' ' + this.$t('Cancelled').toLowerCase())
      }
    },
    setOpenedGroups () {
      if (!this.opendGroup[1]) this.opendGroup[1] = this.form.group1
      if (!this.opendGroup[2]) this.opendGroup[2] = this.form.group2
      if (!this.opendGroup[3]) this.opendGroup[3] = this.form.group3
      if (!this.opendGroup[4]) this.opendGroup[4] = this.form.group4
      if (!this.opendGroup[5]) this.opendGroup[5] = this.form.group5
      if (!this.opendGroup[6]) this.opendGroup[6] = this.form.group6
      if (!this.opendGroup[7]) this.opendGroup[7] = this.form.group7
      if (!this.opendGroup[8]) this.opendGroup[8] = this.form.group8
      if (!this.opendGroup[9]) this.opendGroup[9] = this.form.group9
      if (!this.opendGroup[10]) this.opendGroup[10] = this.form.group10
      if (!this.opendGroup[11]) this.opendGroup[11] = this.form.group11
    },
    setInitOpenedGroups () {
      this.opendGroup[1] = this.form.articles.some(a => a.groupNo === '1')
      this.opendGroup[2] = this.form.articles.some(a => a.groupNo === '2')
      this.opendGroup[3] = this.form.articles.some(a => a.groupNo === '3')
      this.opendGroup[4] = this.form.articles.some(a => a.groupNo === '4')
      this.opendGroup[5] = this.form.articles.some(a => a.groupNo === '5')
      this.opendGroup[6] = this.form.articles.some(a => a.groupNo === '6')
      this.opendGroup[7] = this.form.articles.some(a => a.groupNo === '7')
      this.opendGroup[8] = this.form.articles.some(a => a.groupNo === '8')
      this.opendGroup[9] = this.form.articles.some(a => a.groupNo === '9')
      this.opendGroup[10] = this.form.articles.some(a => a.groupNo === '10')
      this.opendGroup[11] = this.form.articles.some(a => a.groupNo === '11')
    },
    showArticle (val) {
      let show = false
      if ((this.form.group1 && val.groupNo === '1') || (!this.form.group1 && val.value)) show = true
      if ((this.form.group2 && val.groupNo === '2') || (!this.form.group2 && val.value)) show = true
      if ((this.form.group3 && val.groupNo === '3') || (!this.form.group3 && val.value)) show = true
      if ((this.form.group4 && val.groupNo === '4') || (!this.form.group4 && val.value)) show = true
      if ((this.form.group5 && val.groupNo === '5') || (!this.form.group5 && val.value)) show = true
      if ((this.form.group6 && val.groupNo === '6') || (!this.form.group6 && val.value)) show = true
      if ((this.form.group7 && val.groupNo === '7') || (!this.form.group7 && val.value)) show = true
      if ((this.form.group8 && val.groupNo === '8') || (!this.form.group8 && val.value)) show = true
      if ((this.form.group9 && val.groupNo === '9') || (!this.form.group9 && val.value)) show = true
      if ((this.form.group10 && val.groupNo === '10') || (!this.form.group10 && val.value)) show = true
      if ((this.form.group11 && val.groupNo === '11') || (!this.form.group11 && val.value)) show = true
      return show
    },
    groupChanged () {
      // Filter groupedArticles
      const filtered = this.groupedArticles.filter(a =>
        a.groupNo === (this.form.group1 || this.opendGroup[1] ? '1' : '') || a.groupNo === (this.form.group2 || this.opendGroup[2] ? '2' : '') || a.groupNo === (this.form.group3 || this.opendGroup[3] ? '3' : '') || a.groupNo === (this.form.group4 || this.opendGroup[4] ? '4' : '') ||
        a.groupNo === (this.form.group5 || this.opendGroup[5] ? '5' : '') || a.groupNo === (this.form.group6 || this.opendGroup[6] ? '6' : '') || a.groupNo === (this.form.group7 || this.opendGroup[7] ? '7' : '') || a.groupNo === (this.form.group8 || this.opendGroup[8] ? '8' : '') ||
        a.groupNo === (this.form.group9 || this.opendGroup[9] ? '9' : '') || a.groupNo === (this.form.group10 || this.opendGroup[10] ? '10' : '') || a.groupNo === (this.form.group11 || this.opendGroup[11] ? '11' : ''))

      // Remember opend groups
      this.setOpenedGroups()

      // Map to articles
      const mapped = filtered.map(item => {
        return {
          id: item.obj.Id,
          value: '',
          no: item.no,
          name: item.name,
          text: item.text,
          unit: item.unit,
          groupNo: item.groupNo
        }
      })
      // Reload any already entered values
      this.form.articles.forEach(item => {
        const newValue = mapped.find(m => m.text === item.text)
        if (item.value && newValue) newValue.value = item.value
      })
      // Set new articles
      this.form.articles = mapped

      this.recalc()
    },
    bold (val) {
      return val ? 'font-weight-bold' : ''
    },
    isNumber: function (val) {
      val = (val) || window.event
      var charCode = (val.which) ? val.which : val.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        val.preventDefault()
      } else {
        return true
      }
    },
    isHide (fieldName) {
      return false
    },
    isReadonly (fieldName) {
      return false
    },
    isRequired (fieldName) {
      return true
    },
    async approve () {
      // RefreshWeight
      const res = await Classifier.loadRegistration(this.$route.params.id)
      if (!res.failed) {
        const newComments = this.clasReg.Registration.Comment1 // Save Comment1
        this.clasReg.Registration = res.data.Registration // only update Registration (not ClassifierRegistration)
        this.clasReg.Registration.Comment1 = newComments // Reset Comment1
        this.recalc()
      } // data not a list

      // Add positive MissingWeight value to RemainingArticleNo
      if (this.form.MissingWeight > 0 && this.clasReg.RemainingArticleNo) {
        var addToArticle = this.form.articles.find(a => a.no === this.clasReg.RemainingArticleNo)
        if (addToArticle) {
          addToArticle.value += this.form.MissingWeight
          this.recalc()
        }
      }
      // if MissingWeight = 0 just approve, else ask user in confirmMissingWeightDialog
      if (this.form.MissingWeight === 0) { this.form.approvedReg = this.clasReg; this.saveAndLeave() } else { this.confirmMissingWeightDialog = true }
    },
    async saveAndLeave () {
      this.save()
      // Jump to Classifier Registrations
      this.$router.push({ name: this.redirectTo })
    },
    async save () {
      this.preventLeave = false
      if (this.$refs.form.validate()) {
        this.saving = true

        // Convert Articles
        this.clasReg.Articles = this.form.articles.map(item => {
          return {
            Id: item.id,
            ClassifierRegistrationId: this.clasReg.Id,
            Amount: item.value !== '' ? item.value : 0,
            No: item.no,
            Name: item.name,
            Unit: item.unit,
            ArticleGroup: item.groupNo
          }
        })

        var res = null
        // Save/approve Reg with Groups and Articles
        if (this.form.approvedReg) {
          this.clasReg.Registration.ExtraDataNo = 3 // 'Classifier Approved'

          // Convert group checkmarks to Groups for all opendGroups
          const groups = [
            (this.form.group1 || this.opendGroup[1] ? 1 : 0), (this.form.group2 || this.opendGroup[2] ? 2 : 0), (this.form.group3 || this.opendGroup[3] ? 3 : 0), (this.form.group4 || this.opendGroup[4] ? 4 : 0), (this.form.group5 || this.opendGroup[5] ? 5 : 0), (this.form.group6 || this.opendGroup[6] ? 6 : 0),
            (this.form.group7 || this.opendGroup[7] ? 7 : 0), (this.form.group8 || this.opendGroup[8] ? 8 : 0), (this.form.group9 || this.opendGroup[9] ? 9 : 0), (this.form.group10 || this.opendGroup[10] ? 10 : 0), (this.form.group11 || this.opendGroup[11] ? 11 : 0)
          ].filter(g => g !== 0)
          this.clasReg.Groups = groups

          res = await Classifier.approveRegistration(this.clasReg)
        } else {
          this.clasReg.Registration.ExtraDataNo = 2 // 'Classifier Sorting'

          // Convert group checkmarks to Groups for selected groups
          const groups = [
            (this.form.group1 ? 1 : 0), (this.form.group2 ? 2 : 0), (this.form.group3 ? 3 : 0), (this.form.group4 ? 4 : 0), (this.form.group5 ? 5 : 0), (this.form.group6 ? 6 : 0),
            (this.form.group7 ? 7 : 0), (this.form.group8 ? 8 : 0), (this.form.group9 ? 9 : 0), (this.form.group10 ? 10 : 0), (this.form.group11 ? 11 : 0)
          ].filter(g => g !== 0)
          this.clasReg.Groups = groups

          res = await Classifier.saveRegistration(this.clasReg)
        }
        this.saving = false
        if (!res.failed) {
          if (this.form.approvedReg) { this.$root.$message.showSuccess(this.approvedText) } else { this.$root.$message.showSuccess(this.savedText) }
        } else {
          this.$root.$message.showError('Error saving Classifier registration')
        }
      }
    },
    async saveClassifierRegistration () {
      // Convert Articles
      this.clasReg.Articles = this.form.articles.map(item => {
        return {
          Id: item.id,
          ClassifierRegistrationId: this.clasReg.Id,
          Amount: item.value !== '' ? item.value : 0,
          No: item.no,
          Name: item.name,
          Unit: item.unit,
          ArticleGroup: item.groupNo
        }
      })
      this.clasReg.Registration.ExtraDataNo = 2 // 'Classifier Sorting'
      this.clasReg.Registration.Comment4 = 'Sorting Start ' + DateUtil.getTimeSeconds(Date.now())

      // Convert group checkmarks to Groups for selected groups
      const groups = [
        (this.form.group1 ? 1 : 0), (this.form.group2 ? 2 : 0), (this.form.group3 ? 3 : 0), (this.form.group4 ? 4 : 0), (this.form.group5 ? 5 : 0), (this.form.group6 ? 6 : 0),
        (this.form.group7 ? 7 : 0), (this.form.group8 ? 8 : 0), (this.form.group9 ? 9 : 0), (this.form.group10 ? 10 : 0), (this.form.group11 ? 11 : 0)
      ].filter(g => g !== 0)
      this.clasReg.Groups = groups
      await Classifier.saveRegistration(this.clasReg)
    },
    async saveClassifierRegistrationCancel () {
      // Convert Articles
      this.clasReg.Articles = this.form.articles.map(item => {
        return {
          Id: item.id,
          ClassifierRegistrationId: this.clasReg.Id,
          Amount: item.value !== '' ? item.value : 0,
          No: item.no,
          Name: item.name,
          Unit: item.unit,
          ArticleGroup: item.groupNo
        }
      })
      // Convert group checkmarks to Groups for selected groups
      const groups = [
        (this.form.group1 ? 1 : 0), (this.form.group2 ? 2 : 0), (this.form.group3 ? 3 : 0), (this.form.group4 ? 4 : 0), (this.form.group5 ? 5 : 0), (this.form.group6 ? 6 : 0),
        (this.form.group7 ? 7 : 0), (this.form.group8 ? 8 : 0), (this.form.group9 ? 9 : 0), (this.form.group10 ? 10 : 0), (this.form.group11 ? 11 : 0)
      ].filter(g => g !== 0)
      this.clasReg.Groups = groups

      // Undo Registration.ExtraDataNo = 2 // 'Classifier Sorting in progress' => Registration.ExtraDataNo = 1 // 'Unsorted'
      if (this.clasReg.Articles.length === 0 && this.clasReg.Groups.length === 0) {
        this.clasReg.Registration.ExtraDataNo = 1 // 'Unsorted'
        this.clasReg.Registration.Comment4 = ''
        await Classifier.saveRegistration(this.clasReg)
      }
    },
    async loadClassifierRegistration () {
      const res = await Classifier.loadRegistration(this.$route.params.id)
      if (!res.failed) {
        this.clasReg = res.data // data not a list

        // skip registration if cancelled (by SX Change Registration on 2. weighings)
        if (this.clasReg.Registration.Cancelled) this.$router.push({ name: this.redirectTo })

        // Convert from Groups to group checkmarks
        this.form.group1 = this.clasReg.Groups.some(g => g === '1')
        this.form.group2 = this.clasReg.Groups.some(g => g === '2')
        this.form.group3 = this.clasReg.Groups.some(g => g === '3')
        this.form.group4 = this.clasReg.Groups.some(g => g === '4')
        this.form.group5 = this.clasReg.Groups.some(g => g === '5')
        this.form.group6 = this.clasReg.Groups.some(g => g === '6')
        this.form.group7 = this.clasReg.Groups.some(g => g === '7')
        this.form.group8 = this.clasReg.Groups.some(g => g === '8')
        this.form.group9 = this.clasReg.Groups.some(g => g === '9')
        this.form.group10 = this.clasReg.Groups.some(g => g === '10')
        this.form.group11 = this.clasReg.Groups.some(g => g === '11')

        // Map to form articles
        this.form.articles = this.clasReg.Articles.map(item => {
          return {
            id: item.Id,
            value: item.Amount !== 0 ? item.Amount : '',
            no: item.No,
            name: item.Name,
            text: item.No + ' - ' + item.Name,
            unit: item.Unit,
            groupNo: item.ArticleGroup
          }
        })
      } else {
        console.log('Registration not found', this.clasReg.Id)
      }
    }
  },
  beforeDestroy () {
  },
  async mounted () {
    // We need filled params from classifier-registrations - else return
    if (!this.$route.params.sortMethods) this.$router.push({ name: this.redirectTo })

    // initialize parameter
    this.sortMethods = this.$route.params.sortMethods
    this.groupedArticles = this.$route.params.articles

    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })

    if (this.$route.params.id) {
      await this.loadClassifierRegistration()

      // Return if Registration is Cancelled (when SX Change Registration on 2. weighings to Cancelled)
      if (this.clasReg.Registration.Cancelled === false) {
        // Remember opend groups
        this.setInitOpenedGroups()
        this.recalc() // Recalculate amounts and possible articles for remaining amount

        // Save and reload - to avoid bad sync (via ScanPortal reference counter in Amount)
        await this.saveClassifierRegistration()
        await this.loadClassifierRegistration()

        // Remember opend groups
        this.setInitOpenedGroups()

        this.recalc() // Recalculate amounts and possible articles for remaining amount
      } else this.$router.push({ name: this.redirectTo })
    }

    this.savedText = this.$t('Saved')
    this.approvedText = this.$t('Approved')

    this.$nextTick(() => {
      this.loading = false
    })
  }
}
</script>
<style>
.valuefield input::placeholder {
  color: black!important;
  font-style: italic;
  font-size: 90%;
  opacity: 0.7
}

.scrollcard {
   overflow-y: scroll
}

.textright {
 position: absolute; right: 0;
}

</style>
